import React from 'react';

const ErrorMessage = ({ message }) => {
  return (
    <div className="error-container">
      <strong>Error:</strong> {message}
    </div>
  );
};

export default ErrorMessage;
